export enum FilterBtnType {
	CONSENT_WAIT = 'consetn_wait',
	NO_ORDERS = 'no_orders',
}

export enum LEAD_BEARER {
	SMS = 'sms',
	PAPER = 'paper',
	DIGITAL = 'digital',
	ABSENT = 'absent',
}

export enum PARENT_TYPE_LEAD {
	REQUEST = 'Rbidos::Request',
	LIQUIDATION = 'Rbidos::Change',
	BROKER = 'Bg::Request',
	ORDER = 'SberMq::Order',
	RESERVE_ACCOUNT = 'SberMq::ReserveAccount',
	NOTARY = 'SberMq::ExternalFormNotary',
	USER = 'User',
}

export enum NotaryFileType {
	NOTARY_FILE = 'notary_file',
	NOTARY_FILE_SECOND = 'notary_file_second',
	NOTARY_FILE_THIRD = 'notary_file_third',
}
